import React from "react";

const defaultContextValue = null;

const ReportContext = React.createContext<any>(defaultContextValue);

export default ReportContext;
